/**
 * Утилиты для обработки форм
 */

export interface FormSubmissionResult {
  success: boolean;
  data?: Record<string, unknown>;
  error?: string;
}

/**
 * Отправляет форму на указанный эндпоинт
 * @param endpoint URL API эндпоинта
 * @param formData FormData для отправки
 * @returns Promise с результатом отправки
 */
export async function submitForm(
  endpoint: string,
  formData: FormData
): Promise<FormSubmissionResult> {
  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.error || 'Failed to submit application'
      };
    }

    const data = await response.json();
    
    return {
      success: true,
      data
    };
  } catch (error) {
    console.error('Form submission error:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'An unexpected error occurred'
    };
  }
}

/**
 * Сбрасывает форму если она существует
 * @param formElement HTMLFormElement или null
 */
export function resetForm(formElement: HTMLFormElement | null): void {
  if (formElement) {
    formElement.reset();
  }
}
